import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DefaultIconSelect, DefaultIconsPoiMapping, NetworkConstants } from 'diwimamodelweb/lib';
import { removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { IconPickerComponent } from '../icon-picker/icon-picker.component';
import { PoiTypeSettingForm } from '../model/form';
import { UserFeedbackService } from '../user-feedback.service';
import { deepCopy } from 'diwimamodelweb/src';
import { validColorValidator } from 'ngx-colors';
import { SettingsService } from '../settings.service';
import { firstValueFrom, skipWhile, take } from 'rxjs';

@Component({
  selector: 'app-setting-geo-object-type-form',
  templateUrl: './setting-geo-object-type-form.component.html',
  styleUrls: ['./setting-geo-object-type-form.component.css', '../../app.component.scss']
})
export class SettingGeoObjectTypeFormComponent implements OnInit {

  @Input() data: PoiTypeSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService

  deleteRight = false
  updateRight = false
  colorPalette = []
  geoObjectSettingForm: FormGroup
  isCreate = false
  iconChanged = false
  newIconName : string
  oldIconName : string
  saved = false
  typeColorNameData:any
  typeColorNameOpacity:any =1
  oldData: any
  newChanges = false
  newAvalue:string
  defaultIconsDropdown: any[] = [
    {iconName: "no_icon", iconAssetName: "undefined"}
  ]
  defaultIconsDropdownPoi: any[] = [
    {iconName: "no_icon", iconAssetName: "undefined"}
  ]
 
  constructor(private userFeedbackService: UserFeedbackService,
    public dialog: MatDialog,
    private settingsService: SettingsService) { }

  async ngOnInit(): Promise<void> {

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false

    DefaultIconSelect.forEach((value, key) => {
      this.defaultIconsDropdown.push({iconName: key, iconAssetName: value})
    })

    DefaultIconsPoiMapping.forEach((value, key) => {
      this.defaultIconsDropdownPoi.push({iconName: key, iconAssetName: value})
    })
    this.defaultIconsDropdown.shift();

    if (!this.data.data) {
      this.isCreate = true
    }
    this.geoObjectSettingForm = this.formBuilder.group({
      colorName:[undefined, validColorValidator()],
      title: [, Validators.required],
      iconName: [],
      additionalObjects: [false],
      heading: [false],
      shotRanges: [false],
      usageInformation: [false],
      typeColorName:[undefined],
      testInterval:[false],
      notificationChannel: [false]
    })
   
    if (this.data.data) {
      this.initializeWithData()
    }
   
    if (this.data.data){
      this.oldData=this.data.data
    }

    this.geoObjectSettingForm.valueChanges.subscribe( (value) => {
      this.typeColorNameData = deepCopy(value.colorName)
      this.newChanges=true
    })
  }


  initializeWithData() { 
    this.typeColorNameData = this.data.data.colorName
    const {title, iconName, displayOptions, identifier} = this.data.data
    var {colorName} = this.data.data
    let icName = iconName
    if (!icName) {
      // check if default icon...
      const iconAssetName = DefaultIconsPoiMapping.get(identifier)
      if (iconAssetName) {
        DefaultIconSelect.forEach((value, key) => {
          if (value == iconAssetName) {
            icName = key
            return
          }
        })
      }
    }
    if (!icName) icName = "no_icon"

    this.oldIconName = icName

    this.geoObjectSettingForm.patchValue({
      title, iconName: icName, 
      additionalObjects: (displayOptions?.additionalObjects) ? true : false,
      heading: (displayOptions?.heading) ? true : false,
      shotRanges: (displayOptions?.shotRanges) ? true : false, 
      usageInformation: (displayOptions?.usageInformation) ? true : false,
      testInterval:(displayOptions?.testInterval) ? true : false,
      colorName : colorName ? colorName : undefined,
      notificationChannel: (displayOptions?.notificationChannel) ? true : false
    })

    if(this.iconChanged){
      this.geoObjectSettingForm.patchValue({
        title, iconName: this.newIconName, 
        additionalObjects: (displayOptions?.additionalObjects) ? true : false,
        heading: (displayOptions?.heading) ? true : false,
        shotRanges: (displayOptions?.shotRanges) ? true : false, 
        usageInformation: (displayOptions?.usageInformation) ? true : false,
        testInterval:(displayOptions?.testInterval) ? true : false,
        notificationChannel: (displayOptions?.notificationChannel) ? true : false,
        colorName : colorName ? colorName : undefined
      })
    }

  }

  numberToHex(n){
    if(n<1){
      const nhex=n.toString(16)
      this.newAvalue=nhex.slice(2,4) 
    }
    if(n==1){
      this.newAvalue=""
    }
    if(n==0){
      this.newAvalue="00"
    }
  }

  onSubmit() {
    const {title, iconName, additionalObjects, heading, shotRanges, usageInformation, testInterval, notificationChannel, colorName} = this.geoObjectSettingForm.value 
    let icName = (iconName != "no_icon") ? iconName : undefined

    if (this.isCreate) {
      let setting: any = {
        title, identifier: title.toLowerCase(), iconName: icName,
        displayOptions: {
          additionalObjects, heading, shotRanges, usageInformation, testInterval, notificationChannel
        },
        colorName
      }
      const cleaned = removeUndefined(setting)
      this.data.onCreate(cleaned)
    } else {
      let displayOptions: any = {
          additionalObjects, heading, shotRanges, usageInformation, testInterval, notificationChannel
      }
      this.data.data.title = title
      this.data.data.iconName = icName
      if (colorName)
        this.data.data.colorName = colorName
      if (!icName) {
        delete this.data.data.iconName
      }

      if (this.iconChanged){
        this.data.data.iconName=this.newIconName
      }
      this.data.data.displayOptions = displayOptions
      this.data.onSubmit()
    }
    this.saved=true
  }

  onDelete(){
    this.data.onDelete(this.data)
  }

  async openIconPicker(info){
    this.userFeedbackService.loading.emit(false)    
    
    var IPtitle=""
    const titlex = await this.translateService.instant('iconNames.iconPicker')
    
    const titleNew = await this.translateService.instant('iconNames.iconPickerNew')

    if(!this.data.data){
      IPtitle=titleNew

    }else{
      if(this.data.data.title==undefined){
        IPtitle=titleNew
      }else{

        IPtitle=titlex+" " +this.data.data.title

      }
    }
      
    const dialogRef= this.dialog.open( IconPickerComponent, {
      data: {
        title: IPtitle,
        allIcons: this.defaultIconsDropdown,
        dataToChange: this.geoObjectSettingForm.value,
      },
    })


    dialogRef.afterClosed().subscribe(result => {

      if(result){
        this.geoObjectSettingForm.patchValue({iconName: result.iconName})

        if(this.data.data){
          this.data.data.iconName = result.iconName
        }
        
        this.newIconName=result.iconName
        this.iconChanged=true
      }
      
      
    })
  }
}
